import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Box } from "@mui/material";

import {
  useMalimaxOne,
  generateMalimaxOnePdfReportbyId,
} from "../../../../../libs/apis";
import { MalimaxOneI } from "../../../../../libs/interfaces";
import { SendReport } from "../../../../../libs/shared";
import { DashboardTable } from "./dashboard-table";
import type { ColumnsType } from "antd/es/table";
import { useWidth } from "../../../../../libs/hooks";
import { useNavigate } from "react-router-dom";
import "../../../../../libs/css/list.css";
import { Button as ButtonAntd, Tooltip as TooltipAntd, message } from "antd";
import {
  FilePdfOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import { ShowContainer } from "../../../../../components/malimax-container/components/list/show-container";

const titleExport = "Flujos";
const routeEdit = "/workflow/one/edit/";

const MalimaxOneListComponent = () => {
  const width = useWidth();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [sorting, setSorting] = useState([{ id: "id", desc: true }]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: width === "ab" ? 25 : width === "xl" ? 20 : 15,
  });
  const [globalFilter, setGlobalFilter] = useState("");
  const { malimaxOnesQuery } = useMalimaxOne({
    sorting,
    pagination,
    globalFilter,
  });
  const { data, isLoading, refetch, isRefetching } = malimaxOnesQuery;
  const [rowSelection, setRowSelection] = useState({});

  const [isGeneratingPdf, setGeneratingPdf] = useState(false);



  const columns = useMemo<ColumnsType<MalimaxOneI>>(
    () => [
      {
        title: "N° Contenedor",
        dataIndex: "container",
        width: 160,
        render: (value: string, row: MalimaxOneI) => (
          <a className="b-proform" onClick={() => handleNavigate(row)}>
            {value}
          </a>
        ),
      },
      {
        title: "Hora Inicio",
        dataIndex: "hourInit",
        width: 110,
        responsive: ["md"],
      },
      {
        title: "Hora Final",
        dataIndex: "hourEnd",
        width: 110,
        responsive: ["md"],
      },
      {
        title: "Creación",
        dataIndex: "createdAt",
        width: 160,
        responsive: ["sm"],
      },
    ],
    []
  );




  const handleNavigate = useCallback((row: MalimaxOneI) => {
    const routePath = routeEdit + row.id;
    navigate(routePath);
  }, []);

  const handlePdf = async (row: MalimaxOneI) => {
    try {
      setGeneratingPdf(true);

      messageApi.open({
        key: "generatePdfKey1",
        type: "loading",
        content: "Generando Pdf",
        duration: 20,
      });

      const { data: dataPdf } = await generateMalimaxOnePdfReportbyId(row.id!);
      messageApi.destroy("generatePdfKey1");
      messageApi.open({
        key: "generatePdfKey4",
        type: "loading",
        content: "Procesando Pdf",
        duration: 1,
        onClose: () => {
          message.success("PDF Descargado", 1);
        },
      });

      const downloadLink = document.createElement("a");
      downloadLink.href = `data:application/pdf;base64,${dataPdf}`;
      downloadLink.target = "__blank";
      downloadLink.download = `Reporte-Proceso-1-${row.container}.pdf`;
      downloadLink.click();
      setGeneratingPdf(false);
    } catch (err: any) {
      messageApi.destroy();
      setGeneratingPdf(false);
      message.error(`Error al generar el pdf: ${err.toString()}`);
    }
  };


  return (
    <Fragment>
      {contextHolder}
      <DashboardTable<MalimaxOneI>
        columns={columns}
        data={data?.data?.dato ?? []}
        total={data?.data?.total ?? 0}
        loading={isLoading || isRefetching}
        pagination={pagination}
        setPagination={setPagination}
        sorting={sorting}
        setSorting={setSorting}
        setGlobalFilter={setGlobalFilter}
        onRefresh={() => refetch()}
        exportTitle="Flujos"
        actionsWidth={140}
        renderActions={(row) => (
          <Box sx={{ display: "flex", gap: "0.4rem", justifyContent: "center" }}>
            <ButtonAntd
              loading={isGeneratingPdf}
              disabled={isGeneratingPdf}
              size="small"
              onClick={() => handlePdf(row)}
              icon={<FilePdfOutlined />}
              danger
            />
            <SendReport id={row.id!} typeWf="complete" />
            <ShowContainer id={row.id!} />
          </Box>
        )}
      />
    </Fragment>
  );
};

export default MalimaxOneListComponent;
